import type { ClientKind } from "@/domain/clients/list-types";

export interface ChatCardSeed {
  clientId: string | null;
  clientQuery: string | null;
  portfolioQuery: string | null;
}

export interface ChatCardClient {
  kind: ClientKind;
  subjectId: string;
  clientLinkId: string;
  label: string;
}

export function chatCardSeed(value: unknown): ChatCardSeed {
  const seed = isRecord(value) ? value : {};
  return {
    clientId: text(seed.clientId),
    clientQuery: text(seed.clientQuery),
    portfolioQuery: text(seed.portfolioQuery),
  };
}

export function chatCardClient(value: unknown): ChatCardClient | null {
  if (!isRecord(value)) return null;
  const { kind, subjectId, clientLinkId, label } = value;
  if (kind !== "individual" && kind !== "corporation") return null;
  if (typeof subjectId !== "string" || subjectId === "") return null;
  if (typeof clientLinkId !== "string" || clientLinkId === "" || typeof label !== "string") {
    return null;
  }
  return { kind, subjectId, clientLinkId, label };
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function text(value: unknown): string | null {
  return typeof value === "string" && value !== "" ? value : null;
}
